import { useMemo } from "react"

import DOMPurify from "dompurify"
import parse, { HTMLReactParserOptions } from "html-react-parser"

const useParsedHtml = (html?: string, options?: HTMLReactParserOptions) => {
  const parsedAndSanatizedHtml = useMemo(() => {
    if (!html) return null

    try {
      const cleanHtml = DOMPurify.sanitize(html)
      return parse(cleanHtml, options)
    } catch (error) {
      console.error("Error parsing HTML:", error)
      return null
    }
  }, [html, options])
  return parsedAndSanatizedHtml
}

export default useParsedHtml
